import { useMemo } from 'react';

interface Playlist {
  __typename: 'Playlist';
}

interface TimeBlock {
  __typename: 'TimeBlock';
}

interface PowerSchedule {
  __typename: 'PowerSchedule';
}

interface Customer {
  __typename: 'Customer';
}

export function useLimits() {
  const playlistsNumberPerCustomerLimit = Number(
    process.env.REACT_APP_PLAYLISTS_NUMBER_PER_CUSTOMER_LIMIT ?? 0,
  );

  const customersNumberPerOrganizationLimit = Number(
    process.env.REACT_APP_CUSTOMERS_PER_ORGANIZATION_LIMIT ?? 0,
  );

  const powerSchedulesNumberPerCustomerLimit = Number(
    process.env.REACT_APP_POWER_SCHEDULES_PER_CUSTOMER_LIMIT ?? 0,
  );

  const timeBlocksNumberPerScheduleLimit = Number(
    process.env.REACT_APP_POWER_SCHEDULES_TIME_BLOCKS_LIMIT ?? 0,
  );

  return useMemo(
    () => ({
      playlists: {
        playlistsNumberPerCustomerLimit,
        isPlaylistsLimitPerCustomerReached: (playlists: Playlist[] | null | undefined) =>
          Boolean(
            playlists &&
              playlistsNumberPerCustomerLimit > 0 &&
              playlists.length >= playlistsNumberPerCustomerLimit,
          ),
      },
      customers: {
        customersNumberPerOrganizationLimit,
        isCustomersLimitPerOrganizationReached: (customers: Customer[] | null | undefined) =>
          Boolean(
            customers &&
              customersNumberPerOrganizationLimit > 0 &&
              customers.length >= customersNumberPerOrganizationLimit,
          ),
      },
      powerSchedules: {
        powerSchedulesNumberPerCustomerLimit,
        isPowerSchedulesLimitPerCustomerReached: (
          powerSchedules: PowerSchedule[] | null | undefined,
        ) =>
          Boolean(
            powerSchedules &&
              powerSchedulesNumberPerCustomerLimit > 0 &&
              powerSchedules.length >= powerSchedulesNumberPerCustomerLimit,
          ),
        timeBlocksNumberPerScheduleLimit,
        isTimeBlocksLimitPerScheduleReached: (timeBlocks: TimeBlock[] | null | undefined) =>
          Boolean(
            timeBlocks &&
              timeBlocksNumberPerScheduleLimit > 0 &&
              timeBlocks.length >= timeBlocksNumberPerScheduleLimit,
          ),
      },
    }),
    [
      customersNumberPerOrganizationLimit,
      playlistsNumberPerCustomerLimit,
      powerSchedulesNumberPerCustomerLimit,
      timeBlocksNumberPerScheduleLimit,
    ],
  );
}
